var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1428 4.85706H3.85704C2.51579 4.85706 1.42847 5.94435 1.42847 7.28563V29.1428C1.42847 30.4841 2.51579 31.5713 3.85704 31.5713H28.1428C29.4841 31.5713 30.5713 30.4841 30.5713 29.1428V7.28563C30.5713 5.94438 29.4841 4.85706 28.1428 4.85706Z",
    stroke: "#005350",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71411 8.49995V1.21423",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.49995V1.21423",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2856 8.49995V1.21423",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2819 14.3571L15.5778 22.0979C15.4417 22.2784 15.2389 22.3966 15.0148 22.4261C14.7907 22.4556 14.5642 22.3938 14.3861 22.2546L10.3128 18.9979C9.95333 18.7102 9.89513 18.1857 10.1828 17.8262C10.4704 17.4668 10.995 17.4086 11.3544 17.6962L14.7511 20.4137L19.9403 13.3712C20.1104 13.1159 20.4072 12.9747 20.7126 13.0038C21.0181 13.0328 21.2829 13.2274 21.4019 13.5102C21.5208 13.793 21.4748 14.1184 21.2819 14.3571Z",
    fill: "#EA7F4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotIcon);
export default __webpack_public_path__ + "static/media/slot-icon.000cd3ff0041e726e2055037a641a43a.svg";
export { ForwardRef as ReactComponent };